<script setup>
import { RouterLink } from 'vue-router';

import EmptyState from '@/components/ds/EmptyState.vue';

defineOptions({ name: 'NotFoundView' });
</script>

<template>
  <div class="not-found">
    <EmptyState
      icon="search"
      title="The page you're looking for doesn't exist."
      body="Check the URL, or head back to where the data lives."
    >
      <template #actions>
        <RouterLink
          to="/"
          class="ds-btn ds-btn--primary ds-btn--md"
        >
          Otera home
        </RouterLink>
      </template>
    </EmptyState>
  </div>
</template>

<style scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
</style>
